// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FM7VM {
  width: 100%;
  border-radius: 24px;
  padding: 22px 16px 16px 16px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  align-items: start;
}
.FM7VM .I5DEv {
  color: #333;
  font-size: 18px;
  font-weight: 700;
}
.FM7VM .Izd6A {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 16px;
  margin-bottom: 12px;
  cursor: pointer;
}
.FM7VM .Izd6A span {
  color: #666;
  font-size: 14px;
}
.FM7VM .KTr8b {
  margin: 16px 0;
  color: #666;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}
.FM7VM .u72b6 {
  height: 98px;
  position: relative;
  border-radius: 12px;
  background: #F8F9FA;
  overflow: hidden;
  padding: 12px;
  display: flex;
  gap: 8px;
  cursor: pointer;
  align-items: center;
}
.FM7VM .u72b6 .FYx8u {
  position: absolute;
  top: 0;
  right: 0;
}
.FM7VM .u72b6 .rcknd {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}
.FM7VM .u72b6 .PMEj2 {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}
.FM7VM .u72b6 .PMEj2 .EsCHm {
  color: #333;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.5;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  white-space: normal;
  word-break: break-all;
}
.FM7VM .u72b6 .PMEj2 .et2Re {
  color: #999;
  font-size: 12px;
  font-weight: 500;
  line-height: 150%;
  margin-top: 2px;
}
.FM7VM .u72b6 .Z3kLD {
  width: 24px;
  height: 24px;
  transform: rotate(90deg);
  margin-left: auto;
  flex-shrink: 0;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.FM7VM .MQy4f {
  color: #666;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}
.FM7VM .DwKII {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.FM7VM .h_UY0 {
  width: 100%;
  border-radius: 10px;
  background: #577CF6;
  height: 40px;
  color: #FFF;
  font-size: 14px;
  font-weight: 700;
  margin-top: 16px;
}
.IBI0G {
  width: 80%;
  height: 21px;
}
.oHlLb {
  width: 60%;
  height: 21px;
  margin-top: 16px;
}
.dUSHq {
  width: 100%;
  height: 98px;
  margin-top: 12px;
  border-radius: 12px !important;
}
.ObNPl {
  font-size: 12px;
}
.MgH04 {
  list-style: none;
  min-width: 250px;
}
.MgH04 li {
  list-style: none;
  padding: 12px 16px;
  color: #333;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  border-radius: 8px;
  transition: all 0.3s ease;
  cursor: pointer;
}
.MgH04 li:hover {
  color: #577CF6;
  text-shadow: 0 0 0 #577CF6, 0.5px 0 0 #577CF6;
  background: #F7F8FF;
}
.LvhFa {
  display: flex;
  gap: 8px;
}
.v07JX {
  color: #999;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 6px;
}
.ismMh {
  color: #333;
  font-size: 16px;
  font-weight: 700;
  line-height: 150%;
}
.Eviyx {
  padding-top: 10px;
}
.k1_7v {
  display: flex;
  flex-direction: row-reverse;
  gap: 18px;
}
.k1_7v .fa5R9 {
  border-radius: 16px;
  padding: 0px 18px;
  border: 1px solid #EAEAEA;
  color: #333;
  font-size: 16px;
  font-weight: 500;
  height: 32px;
  line-height: 30px;
  transition: all 0.3s ease;
  cursor: pointer;
}
.k1_7v .eVM0l {
  border-radius: 16px;
  font-size: 16px;
  height: 32px;
  font-weight: 700;
  background: #577CF6;
}
.k1_7v .cF0Sb {
  border-radius: 16px;
  font-size: 16px;
  height: 32px;
  font-weight: 700;
  background: #FF4D4F;
}
.tMqjr {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tMqjr span {
  color: #333;
  font-size: 18px;
  font-weight: 700;
}
.tMqjr .Af81c {
  cursor: pointer;
  width: 24px;
  height: 24px;
  margin-right: -6px;
  border-radius: 4px;
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
}
.tMqjr .Af81c:hover {
  background: rgba(0, 0, 0, 0.06);
}
.foqEw {
  display: flex;
  justify-content: flex-end;
  gap: 18px;
}
.foqEw .l0E82 {
  width: 114px;
  height: 32px;
  border-radius: 10px;
  border: 1px solid #EAEAEA;
  color: #333;
  font-size: 16px;
  font-weight: 500;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}
.foqEw .nUteq {
  width: 114px;
  height: 32px;
  border-radius: 10px;
  background: #577CF6;
  font-weight: 700;
}
.O4fQ3 {
  padding-top: 14px;
  padding-bottom: 20px;
  overflow: hidden;
}
.O4fQ3 .v8hoA {
  color: #999;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}
.O4fQ3 .v8hoA span {
  line-height: 22px;
}
.O4fQ3 .v8hoA .zYoLJ {
  position: relative;
  top: 2px;
  left: 4px;
}
.O4fQ3 .kMzvO {
  margin-top: 22px;
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 22px;
}
.O4fQ3 .kMzvO .xupyU {
  border-radius: 12px;
  background: #F8F9FA;
  padding: 22px 15px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}
.O4fQ3 .kMzvO .xupyU .scET6 {
  width: 24px;
  height: 24px;
  background: rgba(87, 124, 246, 0.2);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}
.O4fQ3 .kMzvO .xupyU .cm34z {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}
.O4fQ3 .kMzvO .xupyU .cm34z .CVbqc {
  width: 18px;
  height: 18px;
  border: 1px solid #D9D9D9;
  border-radius: 50%;
}
.O4fQ3 .kMzvO .xupyU .M5sQ1 {
  width: 32px;
  height: 32px;
}
.O4fQ3 .kMzvO .xupyU .OhzoH {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}
.O4fQ3 .kMzvO .xupyU .WzTNm {
  color: #333;
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  white-space: normal;
  word-break: break-all;
}
.O4fQ3 .kMzvO .xupyU .TYmGp {
  color: #999;
  font-size: 12px;
  font-weight: 500;
  line-height: 150%;
}
.L4YF9 {
  flex-shrink: 0;
}
.Zr4wQ {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: Zr4wQ 1.5s ease-in-out infinite;
  border-radius: 4px;
}
@keyframes Zr4wQ {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"attachmentManager": `FM7VM`,
	"attachmentManager_title": `I5DEv`,
	"attachmentManagerTitle": `I5DEv`,
	"attachmentManager_content": `Izd6A`,
	"attachmentManagerContent": `Izd6A`,
	"attachmentManager_tip": `KTr8b`,
	"attachmentManagerTip": `KTr8b`,
	"attachmentManager_resume": `u72b6`,
	"attachmentManagerResume": `u72b6`,
	"attachmentManager_otw": `FYx8u`,
	"attachmentManagerOtw": `FYx8u`,
	"attachmentManager_resume_icon": `rcknd`,
	"attachmentManagerResumeIcon": `rcknd`,
	"attachmentManager_resume_content": `PMEj2`,
	"attachmentManagerResumeContent": `PMEj2`,
	"attachmentManager_resume_text": `EsCHm`,
	"attachmentManagerResumeText": `EsCHm`,
	"attachmentManager_resume_size": `et2Re`,
	"attachmentManagerResumeSize": `et2Re`,
	"attachmentManager_resume_remove": `Z3kLD`,
	"attachmentManagerResumeRemove": `Z3kLD`,
	"attachmentManager_resume_other_title": `MQy4f`,
	"attachmentManagerResumeOtherTitle": `MQy4f`,
	"attachmentManager_list": `DwKII`,
	"attachmentManagerList": `DwKII`,
	"attachmentManager_upload": `h_UY0`,
	"attachmentManagerUpload": `h_UY0`,
	"loading_title": `IBI0G`,
	"loadingTitle": `IBI0G`,
	"loading_tip": `oHlLb`,
	"loadingTip": `oHlLb`,
	"loading_content": `dUSHq`,
	"loadingContent": `dUSHq`,
	"attachmentManager_tooltip": `ObNPl`,
	"attachmentManagerTooltip": `ObNPl`,
	"attachmentManager_resume_more": `MgH04`,
	"attachmentManagerResumeMore": `MgH04`,
	"deleteModal_header": `LvhFa`,
	"deleteModalHeader": `LvhFa`,
	"deleteModal_text": `v07JX`,
	"deleteModalText": `v07JX`,
	"renameModal_title": `ismMh`,
	"renameModalTitle": `ismMh`,
	"renameModal": `Eviyx`,
	"renameModal_footer": `k1_7v`,
	"renameModalFooter": `k1_7v`,
	"renameModal_footer_cancel": `fa5R9`,
	"renameModalFooterCancel": `fa5R9`,
	"renameModal_footer_ok": `eVM0l`,
	"renameModalFooterOk": `eVM0l`,
	"deleteModal_footer_ok": `cF0Sb`,
	"deleteModalFooterOk": `cF0Sb`,
	"switchModal_title": `tMqjr`,
	"switchModalTitle": `tMqjr`,
	"switchModal_title_icon": `Af81c`,
	"switchModalTitleIcon": `Af81c`,
	"switchModal_footer": `foqEw`,
	"switchModalFooter": `foqEw`,
	"switchModal_footer_cancel": `l0E82`,
	"switchModalFooterCancel": `l0E82`,
	"switchModal_footer_ok": `nUteq`,
	"switchModalFooterOk": `nUteq`,
	"switchModal_content": `O4fQ3`,
	"switchModalContent": `O4fQ3`,
	"switchModal_content_tip": `v8hoA`,
	"switchModalContentTip": `v8hoA`,
	"switchModal_content_tip_icon": `zYoLJ`,
	"switchModalContentTipIcon": `zYoLJ`,
	"switchModal_content_list": `kMzvO`,
	"switchModalContentList": `kMzvO`,
	"switchModal_content_list_item": `xupyU`,
	"switchModalContentListItem": `xupyU`,
	"switchModal_content_list_item_icon": `scET6`,
	"switchModalContentListItemIcon": `scET6`,
	"switchModal_content_list_item_disabled": `cm34z`,
	"switchModalContentListItemDisabled": `cm34z`,
	"switchModal_content_list_item_disabled_icon": `CVbqc`,
	"switchModalContentListItemDisabledIcon": `CVbqc`,
	"switchModal_content_list_item_img": `M5sQ1`,
	"switchModalContentListItemImg": `M5sQ1`,
	"switchModal_content_list_item_info": `OhzoH`,
	"switchModalContentListItemInfo": `OhzoH`,
	"switchModal_content_list_item_name": `WzTNm`,
	"switchModalContentListItemName": `WzTNm`,
	"switchModal_content_list_item_size": `TYmGp`,
	"switchModalContentListItemSize": `TYmGp`,
	"flex_shrink": `L4YF9`,
	"flexShrink": `L4YF9`,
	"skeleton": `Zr4wQ`
};
export default ___CSS_LOADER_EXPORT___;
